import { ENVIRONMENT_CONFIGS } from '@/constants/environment-configs';
import { Environment } from '@/enums/environment';

const setUpEnvironmentConfig = (environment: Environment): void => {
    const redirectURI: string = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ':' + window.location.port : ''
    }`;

    //fixme temporary azure ad id
    const envData = {
        VITE_AZURE_AD_AUTHORITY: 'https://login.microsoftonline.com/e6170c30-202d-4926-b525-b8b882873f3b',
        VITE_MSAL_REDIRECT_URI: redirectURI,
        VITE_MSAL_POSTLOGOUT_REDIRECT_URI: redirectURI
    };

    window.env = { ...envData, ...ENVIRONMENT_CONFIGS[environment] };
};

export { setUpEnvironmentConfig };
